import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/YoutubeAnalyticsTrendPostById.graphql';
import { Query, QueryyoutubeAnalyticsTrendPostByIdArgs } from '../../__generated__/globalTypes';

export const useYoutubeAnalyticsTrendPostByIdQuery = (
  options?: QueryHookOptions<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useYoutubeAnalyticsTrendPostByIdLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>
): QueryResult<Query, QueryyoutubeAnalyticsTrendPostByIdArgs> & {
  getYoutubeAnalyticsTrendPostById: LazyQueryExecFunction<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getYoutubeAnalyticsTrendPostById, result] = useLazyQuery<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getYoutubeAnalyticsTrendPostById, ...result };
};

export const useYoutubeAnalyticsTrendPostByIdPromiseQuery = () => {
  const client = useApolloClient();

  const getYoutubeAnalyticsTrendPostById = useCallback(
    (options?: Omit<QueryOptions<QueryyoutubeAnalyticsTrendPostByIdArgs, Query>, 'query'>) =>
      client.query<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getYoutubeAnalyticsTrendPostById };
};
// Suspense Query Hooks
export const useYoutubeAnalyticsTrendPostByIdSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>
) => {
  const result = useSuspenseQuery<Query, QueryyoutubeAnalyticsTrendPostByIdArgs>(QUERY, {
    ...options
  });

  return result;
};
